import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";
import type { RouteObject } from "react-router-dom";

const hsaFunnelMerchantBreadcrumb = breadcrumbSlot();

export const conversionRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Conversion" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        path: "hsa",
        handle: { breadcrumb: "HSA" },
        children: [
          {
            path: "payment-analytics",
            handle: { breadcrumb: "Payment analytics" },
            async lazy() {
              const { HsaPaymentAnalyticsPage } =
                await import("./hsa-payment-analytics-page");
              return { Component: HsaPaymentAnalyticsPage };
            },
          },
          {
            path: "funnel-analytics",
            handle: { breadcrumb: "LMN Analytics" },
            children: [
              {
                index: true,
                async lazy() {
                  const { HsaFunnelAnalyticsPage } =
                    await import("./hsa-funnel-analytics-page");
                  return { Component: HsaFunnelAnalyticsPage };
                },
              },
              {
                path: ":teamId",
                handle: { breadcrumb: hsaFunnelMerchantBreadcrumb },
                async lazy() {
                  const { HsaFunnelMerchantPage } =
                    await import("./hsa-funnel-merchant-page");
                  return {
                    element: (
                      <HsaFunnelMerchantPage
                        breadcrumb={hsaFunnelMerchantBreadcrumb}
                      />
                    ),
                  };
                },
              },
            ],
          },
        ],
      },
      {
        path: "intent",
        handle: { breadcrumb: "Intent" },
        children: [
          {
            path: "trials",
            handle: { breadcrumb: "Self-serve trials" },
            async lazy() {
              const { IntentTrialsPage } = await import("./intent-trials-page");
              return { Component: IntentTrialsPage };
            },
          },
        ],
      },
      {
        path: "ppu-intent",
        handle: { breadcrumb: "PPU intent" },
        children: [
          {
            path: "self-serve",
            handle: { breadcrumb: "Self-serve" },
            async lazy() {
              const { PpuIntentSelfServePage } =
                await import("./ppu-intent-self-serve-page");
              return { Component: PpuIntentSelfServePage };
            },
          },
        ],
      },
    ],
  },
];
